import { PlanCardConfig } from '@aibees/shared/definition';

export const FREE_PLAN_CONFIG: PlanCardConfig = {
  title: 'Free Plan',
  subtitle:
    'Test the worth of our platform on your business with our free trial.',
  monthlyCreditRate: 0,
  yearlyCreditRate: 0,
  tagline: 'Get a Taste',
  priceDescription: 'Always free',
  features: [
    {
      title: 'View First 25 Filter Results',
    },
    {
      title: 'Select up to 25 Records at a time',
    },
    {
      title: 'Unused Credit Rollover',
      disabled: true,
    },
  ],
  featuresDescription: [
    'This Limits you to view only the first 25 results in each search result.',
    'This limits you to select only a maximum of 25 Records at a time.',
    'All your unused Credits will rollover in any paid plan.',
  ],
  defaultCredit: 100,
  options: [],
  buttonText: 'Get Started',
  disabled: false,
};

export const USAGE_BASED_PLAN_CONFIG: PlanCardConfig = {
  title: 'Usage-Based Plan',
  subtitle:
    'Pay for what you need. Choose a credit package that fits your current needs.',
  monthlyCreditRate: 0.027,
  yearlyCreditRate: 0.0216,
  tagline: 'Scale On Demand',
  priceDescription: 'Per Months',
  features: [
    {
      title: 'View Unlimited Filter Results',
    },
    {
      title: 'Select 10k Records at a time',
    },
    {
      title: 'Unused Credit Rollover',
    },
  ],
  featuresDescription: [
    'You no longer have the limitation to view the first 25 results.',
    'You are limited to select only 12,500 Records at a time, instead of the standard 25 in the Free plan.',
    'All your unused Credits will rollover in any paid plan.',
  ],
  defaultCredit: 1000,
  options: [],
  buttonText: 'Get Started',
  disabled: true,
};

export const config: PlanCardConfig[] = [
  FREE_PLAN_CONFIG,
  USAGE_BASED_PLAN_CONFIG,
];
